<div class="seller-agent-container">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #sellerAgentForm="ngForm" class="seller-agent-form">
    <div class="section-header mb-3">
      <h5>Seller Real Estate Agent</h5>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="noSellerRealEstateAgent"
            name="noSellerRealEstateAgent"
            [(ngModel)]="formData.noRealEstateAgent">
          <label class="form-check-label" for="noSellerRealEstateAgent">
            No Real Estate Agent Used
          </label>
        </div>
      </div>
    </div>

    @if (!formData.noRealEstateAgent) {
    <div class="section-subheader mb-3">
      <h6>Company Information</h6>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="companyName">Company Name</label>
          <div class="col-md-9">
            <text-input
                   id="companyName"
                   name="companyName"
                   [(ngModel)]="formData.companyName"
                   [required]="!formData.noRealEstateAgent"
                   maxlength="100">
            </text-input>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="companyLicenseId">Company License ID</label>
          <div class="col-md-9">
            <text-input
                   id="companyLicenseId"
                   name="companyLicenseId"
                   [(ngModel)]="formData.companyLicenseId"
                   maxlength="50">
            </text-input>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="address">Address</label>
          <div class="col-md-9">
            <text-input
                   id="address"
                   name="address"
                   [(ngModel)]="formData.address"
                   maxlength="200">
            </text-input>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="city">City</label>
          <div class="col-md-9">
            <text-input
                   id="city"
                   name="city"
                   [(ngModel)]="formData.city"
                   maxlength="100">
            </text-input>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="state">State</label>
          <div class="col-md-9">
            <select class="form-select"
                    id="state"
                    name="state"
                    [(ngModel)]="formData.state">
              <option value="">-- Select State --</option>
              @for (state of states; track state.value) {
                <option [value]="state.value">
                  {{ state.name }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="zip">Zip</label>
          <div class="col-md-9">
            <text-input
                   id="zip"
                   name="zip"
                   [(ngModel)]="formData.zip"
                   maxlength="20">
            </text-input>
          </div>
        </div>
      </div>
    </div>

    <div class="section-subheader mb-3 mt-4">
      <h6>Contact Information</h6>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="contactName">Contact Name</label>
          <div class="col-md-9">
            <text-input
                   name="contactName"
                   id="contactName"
                   [(ngModel)]="formData.contactName"
                   [required]="!formData.noRealEstateAgent"
                   maxlength="100">
            </text-input>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="contactLicense">Contact License</label>
          <div class="col-md-9">
            <text-input
                   name="contactLicense"
                   id="contactLicense"
                   [(ngModel)]="formData.contactLicense"
                   [required]="!formData.noRealEstateAgent"
                   maxlength="50">
            </text-input>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="contactEmail">Contact Email</label>
          <div class="col-md-9">
            <input class="form-control"
                   name="contactEmail"
                   id="contactEmail"
                   type="email"
                   #contactEmail="ngModel"
                   [(ngModel)]="formData.contactEmail"
                   [ngClass]="{'is-invalid': contactEmail && contactEmail.touched && contactEmail.invalid}"
                   [required]="!formData.noRealEstateAgent"
                   maxlength="100"
                   email />
            <div class="invalid-feedback">
              Please enter a valid email address
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="row">
          <label class="col-md-3 col-form-label" for="contactPhone">Contact Phone</label>
          <div class="col-md-9">
            <input class="form-control"
                   name="contactPhone"
                   id="contactPhone"
                   #contactPhone="ngModel"
                   [(ngModel)]="formData.contactPhone"
                   [ngClass]="{'is-invalid': contactPhone && contactPhone.touched && contactPhone.invalid}"
                   [mask]="'(000) 000-0000'"
                   [showMaskTyped]="true"
                   [required]="!formData.noRealEstateAgent"/>
            <div class="invalid-feedback">
              Please enter a valid phone number.
            </div>
          </div>
        </div>
      </div>
    </div>
    }

  </form>
</div>
